import {Pipe, PipeTransform} from '@angular/core';
import {Backend} from "@generated-backend-types";
import BookingQuestionAnswerOption = Backend.App.Http.Resources.Dashboard.Settings.BookingQuestionAnswerOption;

@Pipe({
    name: 'convertAnswerOptionsToSelectOptions',
    standalone: true
})
export class ConvertAnswerOptionsToSelectOptionsPipe implements PipeTransform {
  transform(answerOptions: BookingQuestionAnswerOption[] | undefined | null, locale: 'de' | 'en'): { key: string, value: string, disabled?: boolean }[] {
    if (!answerOptions) {
      return [];
    }

    return answerOptions.map(option => ({
      key: option.id,
      value: option.answer_option[locale ?? 'de'], // Adjust this based on your data structure
      disabled: false
    }));
  }

}
